import { useRequest } from '@/api/request'
import MiiaFwConfig from '@/configs/config'
import { ERROR_CODES } from '@/constants/error/errorCode'
import type {
  QueryParam,
  QueryResponse
} from '@/types/api/common/governmentSetting/queryGovernmentSettingResponseParam'
import type { ErrorCode } from '@/utils/globalError/entities/valueObjects/types'
import { GlobalError } from '@/utils/globalError/GlobalError'

export const useGovernmentSettingApi = () => {
  const { request } = useRequest()

  /** 自治体設定APIへりクエストする */
  const requestGovernmentSettingApi = <T, U>(func: string, arg: T) => {
    return request<T, U>(MiiaFwConfig.config.apiGwEndpointCommon, '/governmentSettings', func, arg)
  }

  /**
   *自治体設定API queryを実行する
   * @param param リクエストパラメータ
   * @returns レスポンス
   */
  const query = async (param: QueryParam) => {
    const res = await requestGovernmentSettingApi<QueryParam, QueryResponse>('query', param)
    if ('error' in res) {
      throw new GlobalError(
        [ERROR_CODES._811010_API_EXECUTION_FAILED, res.error.errorCode as ErrorCode],
        {
          message: res.error.errorMessage
        }
      )
    }
    return res.result
  }

  return { query }
}
